import { useTranslation } from 'react-i18next';
import FunctionalDialog from 'components/Modals/FunctionalDialog';
import { useAudioFileContext } from 'components/Modals/UploadAudioModal/context';

interface PropsType {
  isOpen: boolean;
  onContinueUploadAudioFile: () => void;
  onClose: () => void;
}

const CancelUploadAudioModal = ({
  isOpen,
  onContinueUploadAudioFile,
  onClose,
}: PropsType) => {
  const { t } = useTranslation();
  const { cancelUploadRequest, setAudioFile } = useAudioFileContext();

  const handleConfirmCancelUploadFile = () => {
    onClose();
    cancelUploadRequest();
    setAudioFile(null);
  };

  return (
    <FunctionalDialog
      title={t('distribution:cancelUploadAudioModal:title')}
      description={t('distribution:cancelUploadAudioModal:description')}
      state={{
        isOpen,
        error: null,
        isLoading: false,
      }}
      action={{
        onSubmit: handleConfirmCancelUploadFile,
        onClose: onContinueUploadAudioFile,
      }}
      submitText={t('distribution:cancelUploadAudioModal:confirmCancelation')}
      closeText={t('distribution:cancelUploadAudioModal:continueUploading')}
      buttonVariant="contained"
      buttonColor="error"
    />
  );
};

export default CancelUploadAudioModal;
